import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(() => {
    // Start with ~23 hours countdown
    const saved = sessionStorage.getItem('urgency-end');
    if (saved) {
      const diff = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      return diff;
    }
    const end = Date.now() + 9 * 60 * 60 * 1000;
    sessionStorage.setItem('urgency-end', end.toString());
    return 9 * 3600;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="w-full bg-[#FFD700] py-3 px-4 text-center sticky top-0 z-50" data-id="element-175">
      <p className="text-[#1a1a1a] font-black text-base md:text-lg tracking-wide" data-id="element-176">
        ⚡ ESPECIAL DE HOY SOLAMENTE $6.39! ⚡
      </p>
      <p className="text-[#D6336C] font-semibold text-sm md:text-base mt-0.5 italic" data-id="element-177">
        Precio Vuelve A $19.99 En{' '}
        <span className="font-black not-italic tracking-wider" data-id="element-178">
          {pad(hours)}:{pad(minutes)}:{pad(seconds)}
        </span>
      </p>
    </div>;
}